import { render, staticRenderFns } from "./ActivityHeaders.vue?vue&type=template&id=5fff0a1e&scoped=true"
var script = {}
import style0 from "./ActivityHeaders.vue?vue&type=style&index=0&id=5fff0a1e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff0a1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fff0a1e')) {
      api.createRecord('5fff0a1e', component.options)
    } else {
      api.reload('5fff0a1e', component.options)
    }
    module.hot.accept("./ActivityHeaders.vue?vue&type=template&id=5fff0a1e&scoped=true", function () {
      api.rerender('5fff0a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/ActivityHeaders.vue"
export default component.exports